import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Autocomplete, Button, Popper, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const CustomButton = styled(Button)({
  backgroundColor: '#FF7959', // Set your desired background color
  color: '#fff', // Set text color
  '&:hover': {
    backgroundColor: '#f1785a', // Set background color on hover
  },
  width: 'fit-content',
});

const StyledPopper = styled(Popper)(({ theme }) => ({
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const Step3 = observer(({ leadPriorities, handleStepComplete }) => {
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [isError, setIsError] = useState(false);

  const stepCompleted = () => {
    if (selectedPriority) {
      setIsError(false);
      handleStepComplete(selectedPriority);
    } else {
      setIsError(true);
    }
  };

  useEffect(() => {
    document.querySelector('#select-priority-autocomplete fieldset').style.borderColor = isError
      ? '#ff0000'
      : 'rgba(0, 0, 0, 0.23)';
    document.querySelector('#select-priority-autocomplete label').style.color = isError
      ? '#ff0000'
      : 'rgba(0, 0, 0, 0.6)';
  }, [isError]);

  return (
    <>
      <Stack direction={'column'} spacing={2}>
        <div id="step1-header">Define your lead stages</div>
        <p id="step-1-p1">
          Deal stages are the steps in your Priority. They mark the real-life milestones in your sales process.
        </p>
        <p id="step-1-p2">Start with renaming them as you like. You can also add, remove or rename stages later.</p>
      </Stack>
      <Stack direction={'column'} spacing={2}>
        <div id="select-priority-autocomplete">
          <Autocomplete
            PopperComponent={StyledPopper}
            disablePortal
            id="select-priority-text"
            options={leadPriorities}
            size="small"
            renderOption={(props, option) => <li {...props}>{option.name}</li>}
            getOptionLabel={(option) => {
              return option.name;
            }}
            onChange={(event, newValue) => {
              setSelectedPriority(newValue);
              setIsError(!newValue);
            }}
            renderInput={(params) => <TextField {...params} label="Select Priority" />}
          />
          <div
            id="priority-error-message"
            className={isError ? '' : 'lm-d-none'}
            style={{ margin: 0, fontSize: '12px', color: '#ff0000' }}
          >
            Please select a Priority
          </div>
        </div>
        <CustomButton variant="contained" onClick={stepCompleted}>
          Done
        </CustomButton>
      </Stack>
    </>
  );
});
